import {
  SET_SEARCH_PARAMS_TECH_EXAM,
  GET_DATA_BY_SEARCH_PARAMS_TECH_EXAM,
  SET_SEARCH_PARAMS_BOATS_TECH_EXAM,
  GET_TECH_EXAM_BOAT_CARDS,
  GET_BOAT_CARD_FOR_TECH_EXAM,
  ADD_NEW_TECH_EXAM_TABLE_INFO,
  ADD_NEW_TECH_EXAM_DATA,
  DELETE_NEW_TECH_EXAM_TABLE_INFO,
  GET_APP_DATA_FOR_EDIT_TECH_EXAM,
  CLEAR_APP_DATA_TECH_EXAM,
} from "../types";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  data: [],
  searchParams: {
    ownerSurname: "",
    ownerName: "",
    ownerMidname: "",
    appNum: "",
    leUnp: "",
    leName: "",
    section: 0,
    status: 0,
  },
  searchParamsBoatCards: {
    ownerSurname: "",
    ownerName: "",
    ownerMidname: "",
    regNum: "",
    leName: "",
    leUnp: "",
    boatVin: "",
    engvin: "",
  },
  dataBoatCards: {},
  newAppTechExam: {
    // appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    // inspector: 1,
    // section: 1,
  },
  boatTo: [],
  // newAccidentData: {},
  personType: "",
  // fileList: [],
};

export const TechnicalExaminationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_TECH_EXAM:
      return (() => ({
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      }))();
    case GET_DATA_BY_SEARCH_PARAMS_TECH_EXAM:
      return (() => ({
        ...state,
        data: action.data,
      }))();
    case SET_SEARCH_PARAMS_BOATS_TECH_EXAM:
      return (() => ({
        ...state,
        searchParamsBoatCards: Object.assign(state.searchParamsBoatCards, action.data),
      }))();
    case GET_TECH_EXAM_BOAT_CARDS:
      return (() => ({
        ...state,
        dataBoatCards: action.data,
      }))();
    case GET_BOAT_CARD_FOR_TECH_EXAM:
      return (() => ({
        ...state,
        newAppTechExam: { ...state.newAppTechExam, ...action.data },
        boatTo: [...action.data.boatTo],
        personType: action.data.personType,
      }))();
    case GET_APP_DATA_FOR_EDIT_TECH_EXAM:
      return (() => ({
        ...state,
        newAppTechExam: { ...state.newAppTechExam, ...action.data },
        boatTo: [...action.data.boatTo],
        personType: !!action.data.nameLe ? 2 : 1,
      }))();

    case ADD_NEW_TECH_EXAM_TABLE_INFO:
      if (action.data.hasOwnProperty("innerId")) {
        const index = state.boatTo.findIndex((item) => item.innerId === action.data.innerId);
        const newArray = [...state.boatTo];
        newArray[index] = action.data;
        return (() => ({
          ...state,
          boatTo: [...newArray],
        }))();
      }
      action.data["innerId"] = uuidv4();
      return (() => ({
        ...state,
        boatTo: [...state.boatTo, action.data],
      }))();
    case ADD_NEW_TECH_EXAM_DATA:
      return (() => ({
        ...state,
        newAppTechExam: { ...state.newAppTechExam, ...action.data },
      }))();
    case DELETE_NEW_TECH_EXAM_TABLE_INFO:
      return (() => ({
        ...state,
        boatTo: [...state.boatTo.filter((item) => item.innerId !== action.data)],
      }))();
    case CLEAR_APP_DATA_TECH_EXAM:
      return (() => ({
        ...state,
        boatTo: [],
        newAppTechExam: {},
        personType: "",
      }))();
    default:
      return state;
  }
};
